<template lang="pug">
    div(ref="infinite", id="infinite" class="insety-16")
        span(class="insetx-8") {{ $t('loading_more_results') }}
        ib-progress-dots
</template>
<script>
    export default {
        name: 'LoadMore',
        data() {
            return {
                isIntersectingElement: false,
                handler: undefined,
                observer: undefined,
            }
        },
        mounted() {
            const infinite = this.$refs.infinite;
            this.handler = (entries) => {
                if (entries[0].isIntersecting) {
                    this.isIntersectingElement = true;
                } else {
                    this.isIntersectingElement = false;
                }
            }

            // This will not work in IE
            this.observer = new window.IntersectionObserver(this.handler);
            this.observer.observe(infinite);
        },
        beforeDestroy() {
            this.observer.unobserve(this.$refs.infinite);
        },
        watch: {
            isIntersectingElement(value) {
                this.$emit('intersecting', value);
            }
        }
    }
</script>

<style scoped lang="less">
    #infinite {
        position: absolute !important; /* The table footer will make this a column if not done */
        width: 100%;
        display: flex;
        align-content: center;
        justify-content: center;
    }
</style>